const validatePromo = (orderId, promoCode, appendResponseTo) => {
    $.ajax({
        url: `/webapp/wcs/stores/servlet/RPMCodeValidateCmd?storeId=301&catalogId=301&langId=-1&jsonResponse=true&orderId=${orderId}&certificate1=${promoCode}`,
        cache: false,
        type: "GET",
        success: function(json) {
        	if(json.JSON){
	        	if(json.JSON.goodCert1){
	        		var displayError = `<div data-twist="appliedPromo-1" id="appliedPromo1" class="prompt alert-success alert" role="success">
						        			<div class="d-flex justify-content-end d-inline-block float-right">
						        				<a data-novalidation="" class="removeReward success-link" data-reward="goodCert1" href="javascript:void(0)">Remove</a>
						        			</div><p style="text-overflow:clip">${promoCode}<br>Congratulations! Your rewards will be applied at checkout.</p>
					        			</div>`;
	        		$(appendResponseTo).append(displayError);
	        		$('form[name="ShopCartForm"]').append(`<input type="hidden" name='goodCert1' value='${promoCode}'/>`);
	        		$('#ajaxPromoCode').val('');
	        		$('#ajaxPromoCode').hide();
	        		$('#ajaxPromoAdd').hide();
	        		
	        		$('.removeReward').on('click', function(){
	        			$('#appliedPromo1').remove();
	        			$('#ajaxPromoCode').show();
	        			$('#ajaxPromoAdd').show();
	        			$('form[name="ShopCartForm"] input[name="goodCert1"]').remove();
	        		});
	        		return true;
	        	} else if(json.JSON.paymentError){
	        		var displayError = `<div data-twist="error-msg" class="wcErrorNoBox ul alert alert-danger" id="ccAuthError">${json.JSON.paymentError}</div>`;
	    			$(appendResponseTo).append(displayError);
	    			return false;
	        	}
        	}
            return false;
        }
    });
};

const setupAjaxPromoValidate = () => {
	$('#ajaxPromoAdd').on('click', function(){
		$('#ccAuthError').remove();
		validatePromo($('input[name="orderId"]').val(), $('#ajaxPromoCode').val(), '#promo-container')
	});
};

export {
	setupAjaxPromoValidate
}